module.exports = __webpack_public_path__ + "media/images/menu/earth-8f8e9c7f3ad3663f26c7088d1e7814df.jpg";